(function () {
  const carousels = document.querySelectorAll('[data-ll-hero-carousel]');
  if (!carousels.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  carousels.forEach(function (carousel) {
    const slides = carousel.querySelectorAll('.ll-story__slide');
    const dots = carousel.querySelectorAll('.ll-story__dot');
    if (slides.length < 2) return;

    let index = 0;
    const interval = parseInt(carousel.dataset.interval, 10) || 6500;

    function goTo(i) {
      slides[index].classList.remove('is-active');
      if (dots[index]) dots[index].classList.remove('is-active');
      index = i;
      slides[index].classList.add('is-active');
      if (dots[index]) dots[index].classList.add('is-active');
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.slideIndex, 10));
      });
    });

    if (!prefersReducedMotion) {
      setInterval(function () {
        goTo((index + 1) % slides.length);
      }, interval);
    }
  });
})();
